// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"7c662902","453":"1ed93f26"}[chunkId] + ".chunk.js";
};